import {Manager} from 'socket.io-client';

import {ApiError} from '../entities/error';
import {IChatConfig} from '../interfaces/chatConfig.interface';

import {GroupSocket} from './groupSocket';
import {MessageSocket} from './messageSocket';

/**
 * @ignore
 * @internal
 * */
export class Socket {
  public static instance: Socket;

  public manager: Manager = null;

  public messageSocket: MessageSocket = null;
  public groupSocket: GroupSocket = null;

  private constructor(config: IChatConfig, success: () => void, errorCallback: (err: ApiError) => void) {
    this.makeManager(config, () => {
      this.makeSockets(() => {
        success();
      }, (error) => {
        errorCallback(error)
      })
    }, (error) => {
      errorCallback(error)
    })
  }

  public static connect(config: IChatConfig) {
    return new Promise<Socket>((resolve, reject) => {
      if (!Socket.instance) {
        const tempInstance = new Socket(config, () => {
          Socket.instance = tempInstance;
          resolve(Socket.instance);
        }, (error) => {
          reject(error);
          // throw error;
        });
      } else {
        resolve(Socket.instance);
      }
    });
  }

  public disconnect() {
    if (Socket.instance) {
      Socket.instance.messageSocket.disconnect();
      Socket.instance.groupSocket.disconnect();

      Socket.instance.manager._close()

      Socket.instance = null;
    }
  }

  private makeManager(config: IChatConfig, success: () => void, errorCallback: (err: ApiError) => void) {
    this.manager = new Manager(config.socketUrl, {
      autoConnect: false,
      reconnectionDelayMax: 10000,
      // reconnectionAttempts: 5,
      query: {
        token: config.userToken
      },
      extraHeaders: {
        token: config.userToken
      }
    });

    this.manager.open((err: Error) => {
      if (err) {
        errorCallback(new ApiError(true, err.message))
      } else {
        success();
      }
    });
  }

  private makeSockets(success: () => void, errorCallback: (err: ApiError) => void) {
    this.messageSocket = new MessageSocket(this.manager, () => {
      if (this.connectionOk()) {
        success();
      }
    }, (err) => {
      errorCallback(err);
    });

    this.groupSocket = new GroupSocket(this.manager, () => {
      if (this.connectionOk()) {
        success();
      }
    }, (err) => {
      errorCallback(err);
    });
  }

  private connectionOk() {
    return this.messageSocket?.connected && this.groupSocket?.connected;
  }
}
